<template>
  <HeroNewsArticle :data="page" />

  <Container indent="center" class="my-16">
    <ComponentsLoader v-editor-target="'content'" :components="page.content" />

    <SocialShareIcons :alternates="page.alternates" class="mt-12 xs:mt-24" />
  </Container>

  <!-- SITE END REPLICATOR -->

  <ComponentsLoader
    v-if="page.news_article_site_end_replicator"
    v-editor-target="'news_article_site_end_replicator'"
    :components="page.news_article_site_end_replicator"
  />
</template>

<script setup>
provide('isNewsArticle', true)

defineProps({
  page: { type: Object, required: true },
})
</script>
